/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon64Regular = forwardRef('ArrowCollapseCHClosedIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M24.818 37.303a7.5 7.5 0 0 0 0-10.606L8.561 10.439a1.5 1.5 0 0 0-2.122 2.122l16.258 16.257a4.5 4.5 0 0 1 0 6.364L6.439 51.44a1.5 1.5 0 1 0 2.122 2.12l16.257-16.257Z" }),
        React.createElement("path", { d: "M39.181 37.303a7.5 7.5 0 0 1 0-10.606L55.44 10.439a1.5 1.5 0 0 1 2.121 2.122L41.303 28.818a4.5 4.5 0 0 0 0 6.364L57.56 51.44a1.5 1.5 0 1 1-2.121 2.12L39.18 37.304Z" })));
});
